var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Relinquish Access ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm._v(
              " Are you sure you want to relinquish the access for “" +
                _vm._s(_vm.service.product) +
                "” - “" +
                _vm._s(_vm.service.domain) +
                "”? "
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [
                _vm._v(" Cancel "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v("button")]
                )
              ]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteAccess
                }
              },
              [
                _vm._v(" Delete "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v("button")]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }